import { createApp } from 'vue';
import App from './App.vue';
import './assets/main.scss';
import router from './router/index';
import imgFallback from './directives/v-img-fallback';
import { VueQueryPlugin } from '@tanstack/vue-query';
//@ts-ignore
import vSelect from 'vue-select';
import * as LucideIcons from 'lucide-vue-next';
import { setPageTitle } from './composables';

const app = createApp(App);

app.use(router).use(VueQueryPlugin);
app.directive('img-fallback', imgFallback);
app.mount('#app');

Object.keys(LucideIcons.icons).forEach((name) => {
  app.component(name, LucideIcons.icons[name].component);
});
app.component('v-select', vSelect);
